import type {
  NotificationOutboxItemView,
  NotificationOutboxStatus,
  PaginatedData,
} from '@solar/contracts';

import { apiClient } from '../../lib/api-client';
import { toQuery } from '../../lib/api-query';

export interface NotificationOutboxFilters {
  page?: number;
  pageSize?: number;
  status?: NotificationOutboxStatus;
}

export const notificationsApi = {
  listOutbox(
    filters: NotificationOutboxFilters = {},
  ): Promise<PaginatedData<NotificationOutboxItemView>> {
    return apiClient.get(`/admin/notifications${toQuery({ ...filters })}`);
  },

  retry(id: string): Promise<NotificationOutboxItemView> {
    return apiClient.post(`/admin/notifications/${encodeURIComponent(id)}/retry`);
  },
};
